import type { Category } from './category';

type BadgeVariant = 'active' | 'done' | 'cancel' | 'pending' | 'neutral' | 'grievance';

/**
 * Order / credential status pill. Maps ONDC order statuses to the warm badge
 * variants; `kind="credential"` renders the ticket auth status (UNCLAIMED / used).
 */
export function StatusBadge({
  status,
  label,
  category,
  kind = 'order',
}: {
  status?: string;
  label?: string;
  category?: Category;
  kind?: 'order' | 'credential';
}) {
  let variant: BadgeVariant = 'neutral';
  let text = label ?? status ?? '';

  if (kind === 'credential') {
    if (status === 'UNCLAIMED') {
      variant = 'active';
      text = label ?? 'Ready to use';
    } else {
      variant = 'neutral';
      text = label ?? 'Used';
    }
  } else {
    const map: Record<string, [BadgeVariant, string]> = {
      ACTIVE: ['active', 'Active'],
      COMPLETED: ['done', category === 'pass' ? 'Visited' : 'Completed'],
      CANCELLED: ['cancel', 'Cancelled'],
      SOFT_CANCEL: ['pending', 'Cancelling'],
      // The operator accepted the cancellation but has not finalised it. Reads as "Cancelling"
      // because that is what it is to the rider — the fallback below would have printed the raw
      // CANCEL_INITIATED enum on a neutral chip.
      CANCEL_INITIATED: ['pending', 'Cancelling'],
    };
    const m = (status && map[status]) || (['neutral', status ?? ''] as [BadgeVariant, string]);
    variant = m[0];
    text = label ?? m[1];
  }

  return (
    <span className={`wb-badge wb-badge--${variant}`}>
      <span className="wb-dot" />
      {text}
    </span>
  );
}
